// Session Storage Utilities - iOS Safari Persistence
// iOS Safari can clear localStorage when the app is backgrounded
// This utility stores tokens in multiple locations for better persistence

export function setSessionToken(token: string): void {
  // 1. localStorage (primary)
  localStorage.setItem('whipt_session_token', token);
  
  // 2. sessionStorage (backup for same-session)
  sessionStorage.setItem('whipt_session_token', token);
  
  // 3. Cookie (most persistent on iOS - 30 days)
  const expires = new Date();
  expires.setDate(expires.getDate() + 30);
  document.cookie = `whipt_session=${token}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  
  console.log('[SessionStorage] Token saved to localStorage, sessionStorage, and cookie');
}

export function getSessionToken(): string | null {
  // Try localStorage first
  let token = localStorage.getItem('whipt_session_token');
  if (token) return token;
  
  // Try sessionStorage
  token = sessionStorage.getItem('whipt_session_token');
  if (token) {
    // Restore to localStorage
    localStorage.setItem('whipt_session_token', token);
    return token;
  }
  
  // Try cookie (most persistent)
  const cookies = document.cookie.split(';');
  const sessionCookie = cookies.find(c => c.trim().startsWith('whipt_session='));
  if (sessionCookie) {
    token = sessionCookie.split('=')[1];
    // Restore to localStorage
    localStorage.setItem('whipt_session_token', token);
    sessionStorage.setItem('whipt_session_token', token);
    return token;
  }
  
  return null;
}

export function clearSessionToken(): void {
  // Clear from all locations
  localStorage.removeItem('whipt_session_token');
  sessionStorage.removeItem('whipt_session_token');
  
  // Clear cookie
  document.cookie = 'whipt_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  
  console.log('[SessionStorage] Token cleared from all locations');
}
